class DummyEmail {
    constructor() {
        this.email = document.querySelector("[id$='register_email_email']");
        this.dummy = document.querySelectorAll("[id*='register_email_dummy']");

        if (!this.email || !this.dummy) {
            return;
        }

        this.dummy.forEach(checkbox => {
            checkbox.addEventListener("change", (event) =>
            {
                if (event.target.value === "1" && event.target.checked) {
                    this.optIn();
                } else if (event.target.value === "0" && event.target.checked) {
                    this.optOut();
                }
            });
        });
    }

    createDummyEmail() {
        const randomNumber = Math.floor(Math.random()* 1000000);
        return `dummy${randomNumber}@dfs.com`;
    }

    optIn() {
        this.email.value = this.createDummyEmail();
        this.email.readOnly = true;
    }

    optOut() {
        this.email.value = "";
        this.email.readOnly = false;
    }
}

export default DummyEmail;
